import { create } from "zustand";

interface ErrorStoreState {
  serverError: any;
  networkError: any;
  setIsServerError: (serverError: any) => void;
  setIsNetworkError: (networkError: any) => void;
}

export const useErrorStore = create<ErrorStoreState>()((set) => ({
  serverError: undefined,
  networkError: undefined,

  setIsServerError: (serverError) => set({ serverError }),
  setIsNetworkError: (networkError) => set({ networkError })
}));
